import { render, staticRenderFns } from "./SubscriptionListPage.vue?vue&type=template&id=25e4a18e&scoped=true"
import script from "./SubscriptionListPage.vue?vue&type=script&lang=js"
export * from "./SubscriptionListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e4a18e",
  null
  
)

export default component.exports